import { Box } from "./Mui";

import { RedPockets } from "./RedPockets";
import { Why } from "./Why";
import { Footer } from "./Footer";
import { Header } from "./Header";

function App() {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        "@media(max-width: 640px)": {
          padding: "0 32px",
        },
      }}
    >
      <Box
        sx={{
          maxWidth: "1040px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Header />

          <Box sx={{ margin: "200px 0 0 0" }}>
            <RedPockets />
          </Box>

          <Box sx={{ margin: "138px 0 0 0" }}>
            <Why />
          </Box>

          <Box sx={{ margin: "140px 0 0 0", padding: "0 0 118px 0" }}>
            <Footer />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default App;
